import {User} from '../../shared/user.model';
import * as AuthActions from './auth.actions';

export interface State {
  token: string;
  authenticated: boolean;
  user: User;
  hasError: boolean;
  error: any;
  loading: boolean;
  redirectTo: string;
  msg: string;
  logout: boolean;
}

const initialState: State = {
  token: null,
  authenticated: false,
  user: null,
  hasError: false,
  error: null,
  loading: false,
  redirectTo: null,
  msg: null,
  logout: false,
};

export function authReducer(state = initialState, action: AuthActions.AuthActions) {
  switch (action.type) {
    case AuthActions.LOGIN_START:
      return {
        ...state,
        hasError: false,
        loading: true
      };
    case AuthActions.FORCE_CHANGE_PASSWORD:
      return {
        ...state,
        user: action.payload.user,
        msg: action.payload.msg,
        loading: false
      };
    case AuthActions.LOGIN_ERROR:
      if (action.payload.error === null) { return state; }
      return {
        ...state,
        authenticated: false,
        hasError: true,
        error: action.payload,
        loading: false
      };
    case AuthActions.CLOSE_ERROR:
      return {
        ...state,
        hasError: false
      };
    default:
      return state;
  }
}

